<h2 mat-dialog-title>{{ practitioner?.name }}</h2>
<page-alert [message]="messageSuccess" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
<page-alert [message]="messageError" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>

<mat-dialog-content class="mat-typography">
  <mat-tab-group (selectedIndexChange)="onTabChange($event)">
    <mat-tab label="Sobre">

      <div class="info" *ngIf="!loading">

        <div class="row">
          <div class="col-md-4 col-lg-4">Nome:</div>
          <div class="col-md-8 col-lg-8">{{ practitioner?.name }}
          </div>
        </div>

        <page-title title="Especialidades:"></page-title>
        <div class="row" *ngFor="let specialty of practitionerRole?.specialtys">
          <div>Nome: {{ specialty.value }}</div>
          <div>CRM: {{ specialty.crm }}</div>
        </div>


         <page-qualifications [qualifications]="practitioner?.qualifications" [certificates]="practitioner?.certificates"
        [languages]="practitioner?.communication"></page-qualifications>

      </div>

    </mat-tab>



    <mat-tab label="Serviços">
      <p class="title">{{ getSpecialtysSectionTitle(data.param.type) }}</p>

      <ng-container *ngIf="data.param.type == 'requested'">

        <p *ngIf="specialtys?.length == 0">Não há especialidades a serem aprovadas</p>
        <mat-card *ngFor="let specialty of specialtys" style="margin-top: 1rem">
          <mat-checkbox (change)="toggleStatus(specialty); toogleCheckSpecialty(specialty);">
            {{ specialty.display }}
          </mat-checkbox>
        </mat-card>
        <div class="btLink">
          <button style="margin-top: 5vh; margin-right: 2vh" [disabled]="!hasCheckedSpecialty()"
            (click)="aproveAffiliation()" mat-flat-button color="primary">
            Aceitar Vinculações
          </button>
          <button style="margin-top: 5vh" [disabled]="!hasCheckedSpecialty()" (click)="rejectSpecialtyAffiliation()"
            mat-flat-button color="danger">Reprovar Vinculações</button>
        </div>
      </ng-container>

      <ng-container *ngIf="data.param.type == 'accepted'">
        <p *ngIf="specialtys?.length == 0">Não há especialidades a serem removidas</p>
        <div class="col-xs-12" *ngFor="let specialty of specialtys">
          <mat-checkbox (change)="toggleStatus(specialty); toogleCheckSpecialty(specialty)">
            {{ specialty.display }}
          </mat-checkbox>
        </div>

        <div class="btLink">

          <button style="margin-top: 5vh; margin-right: 1rem;" (click)="openSelectHealthcareserviceDialog()"
            mat-flat-button color="primary">Novo Serviço</button>

          <button style="margin-top: 5vh" [disabled]="!hasCheckedSpecialty()" (click)="removeAffiliation()"
            mat-flat-button color="primary">Remover Vinculações</button>
        </div>
      </ng-container>

      <ng-container *ngIf="data.param.type == 'cancelled'">
        <div class="col-xs-12" *ngFor="let specialty of specialtys">
          <mat-checkbox (change)="toggleStatus(specialty);" disabled>
            {{ specialty.display }}
          </mat-checkbox>
        </div>


      </ng-container>
    </mat-tab>

    <mat-tab label="Configurações de Procedimentos">
      <p>Aqui você pode cadastrar seu próprio tempo de duração médio de um procedimento:</p>
      <div class="specialty-cards">

        <div *ngFor="let specialty of specialtys; let i = index">
          <form [formGroup]="specialtyForms[i]">
            <div>
              <page-title title="Procedimento referente - {{ specialty.display }}"></page-title>
              <div class="col-xs-12">

                <mat-card class="card-content">
                  <span>{{ specialty.display }}</span>
                  <div class="button-container">
                    <button mat-flat-button color="primary" [disabled]="affiliationStatus == 'cancelled'"
                      (click)="openChangeHoursDialog(specialty)">
                      Definir Horário
                    </button>
                  </div>
                </mat-card>
                <mat-form-field *ngIf="affiliationStatus != 'cancelled'" appearance="outline">
                  <mat-label>Tempo médio de realização (em minutos)</mat-label>
                  <input type="text" matInput placeholder="Tempo médio" formControlName="averageDuration" required />
                  <mat-error *ngIf="specialtyForms[i].get('averageDuration')?.hasError('required')"> O tempo é
                    obrigatório </mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-md-2">
                <mat-checkbox *ngIf="affiliationStatus != 'cancelled'" formControlName="byOrder">
                  Ordem de chegada?
                </mat-checkbox>
              </div>
            </div>

            <div class="actions">
              <button mat-flat-button color="primary" (click)="saveAverageTime()"
                [disabled]="loading || !specialtyForms[i].valid">
                <ng-container *ngIf="!loading && affiliationStatus != 'cancelled'">Salvar</ng-container>
                <ng-container *ngIf="loading">
                  <mat-progress-spinner mode="indeterminate" diameter="20" strokeWidth="3"></mat-progress-spinner>
                </ng-container>
              </button>
            </div>
          </form>
        </div>
      </div>

    </mat-tab>
    <mat-tab label="Solicitações">
      <div class="container">
        <p>Aqui você pode visualizar as solicitações de seu especialista afiliado:</p>

        <mat-card *ngFor="let request of allRequests" [ngClass]="request?.status">
          <div>
            <strong>{{ transformRequestText(request?.requestType) }}</strong><br />
            {{ affiliation?.organization_name }}
          </div>
          <div class="status-label">{{ transformStatusText(request?.status) }}</div>
          <div class="button-container">
            <button mat-flat-button color="primary" (click)="openHoursChangesRequestDetails(request)">Ver
              detalhes</button>
          </div>
        </mat-card>
      </div>
    </mat-tab>

   <mat-tab label="Bloquear Agenda" *ngIf="organizationIsOwner(practitioner)">
      
      <non-working-days [practitioner_id]="data.param?.practioner.practitioner_id" ></non-working-days>
    </mat-tab> 
  </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button  *ngIf="organizationIsOwner(practitioner) && selectedTabIndex == 0" (click)="openToUpdate()" mat-flat-button color="primary" > Editar </button>
  <button mat-button color="primary" [mat-dialog-close]="false">Fechar</button>
</mat-dialog-actions>